<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To all the loyal Bolan-watchers out there who have kept the faith and given meaning to his war, this closer look into the man is gratefully dedicated.</p>
<p class="ded1"><span>dp</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3048d894